import ApiService from "@Src/services/ApiService";

export const REFRESH_TOKEN_ROUTE = {
    REFRESH_USER: "user/refreshtoken"
}

export async function refreshUserToken(data: any) {
    return ApiService.fetchRefreshData({
        url: REFRESH_TOKEN_ROUTE.REFRESH_USER,
        method: "post",
        data,
    });
}